export default {"src":"/_next/static/media/icon-stats-health.3c65f717.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};